
export const peiEndPoints = {
    claimsData: 'provider-effort-index/claims-details',
    effortIndexData: 'provider-effort-index/effort-index',
    serviceMetric:'provider-effort-index/service-metrics',
    avgClaimTatTrend: 'provider-effort-index/claims-details-v2',
    serviceMetricV2:'provider-effort-index/service-metrics-v2',
    effortIndexDataV2: 'provider-effort-index/effort-index-v2',
    effortIndexSummary: 'provider-effort-index/effort-index-summary',
    dateFilterData: '/date-filter-source/PEM/',
    claimsYield: 'provider-effort-index/claims-yield',
}
export const exemptionEndPoints = {
    geoFilter: 'standard-search/topfilter',
    geoExemption: 'contract-exemption/aggregated-tin-summary/',
    totalTins:'contract-exemption/tin-count-category/'
}
export const onBoardingEndPoints = {
    list: '/onboarding-details/?page=',
    save: '/save-onboarding-details',
    images: '/onboarding-image-names',
    unpublish: '/update-onboarding-publish-status/',
}

export const overViewendPoints = {
    topReasonDOP: 'dop-claim-metrics/?request-type=TOP_DENIAL_REASONS',
    topReason: 'claim-metrics/?request-type=NONPAYMENT_TOPCATEGORIES',
    topSubReasonDOP: 'dop-claim-metrics/?request-type=TOP_SUB_DENIAL_REASONS',
    topSubReason: 'claim-metrics/?request-type=NONPAYMENT_TOPSUBCATEGORIES',
    claimsAppealsSubmission: 'claims-appeals-metrics/?request-type=',
    priorAuthTAT: 'prior-authorizations/tat/',
    ClaimSubmission: 'claim-submissions/?request-type=PAYMENT_METRICS',
}

export const goldCardEndPoints = {
    exemptionDetails: '/gold-card/exemption-details/'
}